export default "__VITE_ASSET__b5b3614b__"